import type { Song } from "@libs/wire";
import type { ArtistRef } from "./InboxDetailSheet/types";

type InboxPlaybackCollection = {
  collectionId: string;
  collectionName?: string;
  collectionType: "album" | "artist";
  songId: string;
};

export type SupportedArtistSong = {
  artist: ArtistRef;
  song: Song;
};

/**
 * A recommendation is a catalog song, not an inbox-owned collection.
 * Use the song's real album so every player collection consumer receives a
 * valid catalog collection type and ID.
 */
export const getRecommendationPlaybackCollection = (
  song: Song,
): InboxPlaybackCollection | null => {
  const album = song.albums.at(0);
  if (!album?.id) return null;

  return {
    collectionId: album.id,
    collectionName: album.title,
    collectionType: "album",
    songId: song.id,
  };
};

/**
 * A supported-artist row already identifies a real catalog artist. Keep that
 * artist as the playback collection so restore, navigation, and analytics all
 * use the same catalog identity.
 */
export const getSupportedArtistPlaybackCollection = ({
  artist,
  song,
}: SupportedArtistSong): InboxPlaybackCollection | null => {
  if (!artist.id) return null;

  return {
    collectionId: artist.id,
    collectionName: artist.name,
    collectionType: "artist",
    songId: song.id,
  };
};
